import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { addBreadcrumb, removeBreadcrumb } from 'redux/actions/layoutActions';
import BackgroundBox from 'shared/components/BackgroundBox';
import { LabelIcon } from 'shared/components/Labels';
import { colors } from 'shared/defaultTheme';
import { ReactComponent as LockIcon } from 'assets/icon-lock.svg';
import useClient from 'hooks/useClient';
import { setClientAccessManagerContacts } from 'redux/actions/clientAccessManagerActions';
import { ClientAccessManagerWrapper } from './styles';
import { HeaderActions, Table, ClientAccessManagerSelectorModal } from './components';

const ClientAccessManager = () => {
  const theme = useSelector((state) => state.theme);
  const { breadcrumbs } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { mainColor } = theme;
  const { getAllContacts, getAllContactsLoading } = useClient();

  const fetchAllContacts = async () => {
    const contacts = await getAllContacts({
      filters: [
        {
          model: 'Contact',
          field: 'Name',
          asc: true,
        },
      ],
    });
    dispatch(setClientAccessManagerContacts(contacts));
  };

  useEffect(() => {
    (async () => {
      await fetchAllContacts();
    })();
  }, []);

  useEffect(() => {
    if (breadcrumbs.length > 1) {
      breadcrumbs.forEach(() => {
        dispatch(removeBreadcrumb());
      });
      dispatch(
        addBreadcrumb({
          active: false,
          label: 'general_home',
          link: '/home',
          isModify: false,
        })
      );
    }
    dispatch(
      addBreadcrumb({
        label: 'general_access_manager',
        active: true,
        link: pathname,
        isModify: false,
      })
    );
  }, []);

  return (
    <ClientAccessManagerWrapper className="pb-3">
      <BackgroundBox className="backgroundbox-wrapper">
        <LabelIcon
          label={t('general_access_manager')}
          Icon={() => <LockIcon className="label-icon__client" fill={colors.white} />}
          color={mainColor}
          className="text-uppercase ml-1 label-icon"
        />
        <HeaderActions />
        <Table loading={getAllContactsLoading} />
        <ClientAccessManagerSelectorModal />
      </BackgroundBox>
    </ClientAccessManagerWrapper>
  );
};

export default ClientAccessManager;
